import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "./data";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchNewsPageDataIfNeeded } from "./data/newsPageReducer";

// eslint-disable-next-line import/no-unresolved
const NewsPost = loadable(() => import("./NewsPost"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchNewsPageDataIfNeeded(props));
  }, [dispatch, props?.match?.params?.slug]);

  return (
    <ErrorBoundary>
      <NewsPost {...props} />
    </ErrorBoundary>
  );
};

export { NewsPost as PreFetchNewsPost };
export { loadData };
